import { useEffect, useRef } from "react";
import { useStore } from "../../store/store";
import { gsap } from "gsap";
import AudioManager from "../../utils/AudioManager";
import Bar from "./Bar/Bar";

import s from "./Volume.module.scss";

const Volume = () => {
  const [volume, setVolume] = useStore((state) => [
    state.volume,
    state.setVolume,
  ]);

  const bowser = useStore((state) => state.bowser);

  const onClick = () => {
    if (
      bowser.getPlatformType() !== "desktop" &&
      AudioManager.audioActivated === false
    ) {
      AudioManager.play();
      setVolume(1);
      return;
    }

    setVolume(volume === 0 ? 1 : 0);
    AudioManager.onClickVolumeBtn(volume === 0 ? 1 : 0);
  };

  return (
    <div onClick={onClick} className={s.volume}>
      <Bar muted={volume === 0 ? true : false} scale={0.7} />
      <Bar muted={volume === 0 ? true : false} scale={0.5} />
      <Bar muted={volume === 0 ? true : false} scale={0.6} />
    </div>
  );
};

export default Volume;
